import { useState, useEffect } from 'react';
import axios from 'axios';

const GraphData = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getAuthToken = () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setError('Please log in to continue.');
    }
    return token;
  };

  const fetchClients = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = getAuthToken();
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await axios.get(
        'https://pevbackend.codovio.com/public/api/get-all-clients',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.success) {
        setClients(response.data.data || []);
      } else {
        setError('Failed to load clients.');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching clients:', error);
      setError(error.response?.data?.message || 'Error fetching clients.');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return { clients, loading, error };
};

export default GraphData